<template>
  <div>
    <el-card class="box-card">
      <!-- 上方操作栏 -->
      <div style="display: flex; align-items: center; margin-bottom: 20px;">
        <h3 style="margin-right: 20px;">价格自动更新执行</h3>
        <el-button type="primary" @click="showConfirmDialog">执行自动更新</el-button>
        <div style="display: flex; align-items: center; margin-left: 16px;">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 360px;"
          />
        </div>
      </div>

      <!-- 任务历史列表 -->
      <div v-if="loading" class="loading-container">
        <i class="el-icon-loading"></i>
        <span>正在加载数据...</span>
      </div>

      <div v-else-if="taskList.length === 0" class="empty-container">
        <el-empty description="暂无执行历史" />
      </div>

      <div v-else>
        <el-table :data="taskList" style="width: 100%" border>
          <el-table-column prop="id" label="任务ID" />
          <el-table-column prop="start_date" label="开始点"  />
          <el-table-column prop="end_date" label="结束点"  />
          <el-table-column prop="create_time" label="执行时间"  />
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == 1" :type = "info" size="small">
                执行中
              </el-tag>
              <el-tag v-if="scope.row.status == 2" :type = "success" size="small">
                成功
              </el-tag>
              <el-tag v-if="scope.row.status == 3" :type = "danger" size="small">
                失败
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="viewLog(scope.row)">查看日志</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 确认执行弹窗 -->
      <el-dialog
        title="确认执行自动更新"
        :visible.sync="confirmVisible"
        width="400px"
        center
      >
        <span>确定要执行价格自动更新任务吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="confirmVisible = false">取消</el-button>
          <el-button type="primary" @click="executeTask">确定</el-button>
        </span>
      </el-dialog>

      <!-- 日志详情弹窗 -->
      <el-dialog
        title="执行日志"
        :visible.sync="logVisible"
        width="80%"
        center
      >
        <div v-if="currentLog" style="max-height: 600px; overflow-y: auto;">
          <!-- 基本信息 -->
          <div style="margin-bottom: 20px; padding: 16px; background-color: #f5f7fa; border-radius: 4px;">
            <div style="display: flex; flex-wrap: wrap; gap: 20px;">
              <div>
                <strong>任务ID:</strong> {{ currentLog.id }}
              </div>
              <div>
                <strong>执行时间:</strong> {{ currentLog.create_time }}
              </div>
              <div>
                <strong>开始日期:</strong> {{ currentLog.start_date }}
              </div>
              <div>
                <strong>结束日期:</strong> {{ currentLog.end_date }}
              </div>
              <div>
                <strong>状态:</strong>
                <el-tag v-if="currentLog.status === 1" type="info" size="small">执行中</el-tag>
                <el-tag v-if="currentLog.status === 2" type="success" size="small">成功</el-tag>
                <el-tag v-if="currentLog.status === 3" type="danger" size="small">失败</el-tag>
              </div>
              <div>
                <strong>错误信息:</strong> {{ currentLog.error_message || '无' }}
              </div>
            </div>
          </div>

          <!-- 更新日志表格 -->
          <div>
            <h4 style="margin-bottom: 10px;">更新详情:</h4>
            <el-table :data="Array.isArray(currentLog.update_log) ? currentLog.update_log : []" style="width: 100%; font-size: 14px;">
              <el-table-column prop="cate1" label="系列"  />
              <el-table-column prop="cate2" label="品名"  />
              <el-table-column prop="score" label="分数"  />
              <el-table-column prop="min" label="最小值"  />
              <el-table-column prop="max" label="最大值" />
              <el-table-column prop="avp" label="平均值"  />
            </el-table>
            <div v-if="Array.isArray(currentLog.update_log) && currentLog.update_log.length === 0" style="text-align: center; padding: 20px; color: #909399;">
              暂无更新记录
            </div>
          </div>
        </div>
        <div v-else style="text-align: center; padding: 40px; color: #909399;">
          暂无日志信息
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="logVisible = false">关闭</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "AdminAutoUpdateTask",
  data() {
    return {
      taskList: [],
      loading: false,
      confirmVisible: false,
      logVisible: false,
      currentLog: "",
      dateRange: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  created() {
    this.getTaskHistory();
  },
  methods: {
    // 获取任务历史
    getTaskHistory() {
      this.loading = true;
      request
        .get("/admin/auto-update-price/log", {
          params: {}
        })
        .then((res) => {
          if (res.code === "0") {
            this.taskList = res.data || [];
          } else {
            this.$message({
              type: "error",
              message: res.msg || "获取任务历史失败"
            });
            this.taskList = [];
          }
        })
        .catch((error) => {
          console.error("获取任务历史失败:", error);
          this.$message({
            type: "error",
            message: "获取任务历史失败"
          });
          this.taskList = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 显示确认弹窗
    showConfirmDialog() {
      if (!this.dateRange || this.dateRange.length !== 2) {
        this.$message({
          type: "warning",
          message: "请先选择开始日期和结束日期"
        });
        return;
      }
      this.confirmVisible = true;
    },

    // 执行任务
    executeTask() {
      this.confirmVisible = false;
      this.loading = true;
      request
        .post("/admin/auto-update-price/trigger", null, {
          params: {
            startDate: this.dateRange[0],
            endDate: this.dateRange[1]
          }
        })
        .then((res) => {
          if (res.code === "0") {
            this.$message({
              type: "success",
              message: res.msg || "任务执行成功"
            });
            // 重新加载任务历史
            this.getTaskHistory();
          } else {
            this.$message({
              type: "error",
              message: res.msg || "任务执行失败"
            });
          }
        })
        .catch((error) => {
          console.error("执行任务失败:", error);
          this.$message({
            type: "error",
            message: "任务执行失败"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 查看日志
    viewLog(task) {
      request
        .get("/admin/auto-update-price/log/" + task.id, {
          params: {}
        })
        .then((res) => {
          if (res.code == "0") {
            this.currentLog = res.data;
            // 解析update_log JSON字符串并处理异常
            if (this.currentLog && this.currentLog.update_log) {
              try {
                this.currentLog.update_log = JSON.parse(this.currentLog.update_log);
              } catch (e) {
                console.error("解析update_log失败:", e);
                this.currentLog.update_log = [];
              }
            } else {
              this.currentLog.update_log = [];
            }
            this.logVisible = true;
          } else {
            this.$message({
              type: "error",
              message: res.msg || "获取日志失败"
            });
          }
        })
        .catch((error) => {
          console.error("获取日志失败:", error);
          this.$message({
            type: "error",
            message: "获取日志失败"
          });
        });
    },

    // 分页大小变化
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.getTaskHistory();
    },

    // 当前页变化
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage;
      this.getTaskHistory();
    }
  }
};
</script>

<style scoped>
/* 加载状态样式 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #606266;
}

.loading-container i {
  font-size: 32px;
  margin-bottom: 10px;
  color: #409eff;
  animation: el-rotate 1s linear infinite;
}

/* 空状态样式 */
.empty-container {
  padding: 60px 0;
}

/* 日志样式 */
pre {
  font-family: 'Courier New', Courier, monospace;
  font-size: 14px;
  color: #333;
  background-color: #f5f7fa;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}
</style>